(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('customerManagement', {
            bindings:{
                filters: '=',
                page: '='
            },
            templateUrl: 'app/admin/customer-management/list.html',
            controller: function ($state, CustomerService) {
                this.add = function(){
                    CustomerService.add().then(reload);
                };
                this.edit = function (id) {
                    CustomerService.edit(id).then(reload);
                };
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                function reload() {
                    $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('customer-management', {
                    parent: 'admin',
                    url: '/customer-management?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    views: {
                        'content@': 'customerManagement'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (Customer, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            Customer.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                });
        });

})();
